import React from 'react';

export interface ProviderContext {
}

// @ts-ignore
export default React.createContext<ProviderContext>();